import { fetchEndpointData } from '@utils/fetchEndpointData';

import type {
  ListApiKeysResponse,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  RevokeApiKeyResponse,
} from 'src/app/customer-api/endpoints/admin/ApiKeyEndpoints.types';
import type { ListApiLogsResponse } from 'src/app/customer-api/endpoints/admin/ListApiLogsEndpoint.types';

export async function fetchAdminApiKeys(customerId: number) {
  return fetchEndpointData<ListApiKeysResponse>(`/api/v1/admin/customer-api-keys?customerId=${customerId}`);
}

export async function createAdminApiKey(data: CreateApiKeyRequest) {
  return fetchEndpointData<CreateApiKeyResponse>('/api/v1/admin/customer-api-keys', {
    method: 'POST',
    body: data,
  });
}

export async function revokeAdminApiKey(id: string) {
  return fetchEndpointData<RevokeApiKeyResponse>(`/api/v1/admin/customer-api-keys/${id}`, {
    method: 'DELETE',
  });
}

export async function fetchAdminApiLogs(query: {
  customerId: number;
  apiKeyId?: string;
  startDate?: string;
  endDate?: string;
  cursor?: string;
  limit?: number;
}) {
  const params = new URLSearchParams();
  params.append('customerId', query.customerId.toString());
  if (query.apiKeyId) params.append('apiKeyId', query.apiKeyId);
  if (query.startDate) params.append('startDate', query.startDate);
  if (query.endDate) params.append('endDate', query.endDate);
  if (query.cursor) params.append('cursor', query.cursor);
  if (query.limit) params.append('limit', query.limit.toString());

  return fetchEndpointData<ListApiLogsResponse>(`/api/v1/admin/customer-api-logs?${params.toString()}`);
}
